import Script from 'next/script';
import { useMock } from '../../tracking/utils/useMock';

export const CookieYesBanner = () => {
    if (useMock()) return <></>;
    return <Script id="cookieyes" key="cookieyes" type="text/javascript" src="https://cdn-cookieyes.com/client_data/b5633257490b84b38483f390/script.js" />;
}